module.exports = __webpack_public_path__ + "static/img/gengxintishi.2138048e.png";